var exports = {
  "kL": "xf1bb6bc5--3a8e39--container",
  "DD": "xf1bb6bc5--3a8e39--title",
  "h_": "xf1bb6bc5--3a8e39--description",
  "nf": "xf1bb6bc5--3a8e39--link",
};

module.exports = exports;
